// extracted by mini-css-extract-plugin
export default {"root":"IconVerifiedUser_root__PwIJa"};